import { get } from "lodash"
import queryString from "query-string"
import { createSelector } from "reselect"
import errorCodes from "../../../helpers/errors"

const getRawQuery = () => window.location.search
const getParsedQuery = createSelector(
  [getRawQuery],
  (query) => queryString.parse(query),
)

export const getErrorMessage = createSelector(
  [getParsedQuery],
  (parsedQuery) => {
    const errorCode = get(parsedQuery, "errorCode")
    return get(errorCodes, errorCode)
  },
)

export const getProvider = (state) => get(state, "user.ssoProviderType")
